export const MIN_HEIGHT_CM = 5
/** Character scale-sheet grip drag floor (heroes should not shrink to toy size). */
export const GRIP_DRAG_MIN_HEIGHT_CM = 50
/** Prop scale-sheet absolute / input floor (small props). */
export const PROP_MIN_HEIGHT_CM = 1
/** Prop scale-sheet grip drag floor. */
export const PROP_GRIP_DRAG_MIN_HEIGHT_CM = 1
export const MAX_HEIGHT_CM = 1000

export function clampHeight(value: number, minCm: number = MIN_HEIGHT_CM) {
  return Math.min(MAX_HEIGHT_CM, Math.max(minCm, Math.round(value)))
}

/** Soft cap for layout / legacy values already stored above MAX. */
export function renderHeightCm(cm: number) {
  return Math.min(cm, MAX_HEIGHT_CM)
}

export function clampGripDragHeight(value: number, minCm: number = GRIP_DRAG_MIN_HEIGHT_CM) {
  return Math.min(MAX_HEIGHT_CM, Math.max(minCm, Math.round(value)))
}

export type CommitHeightTextResult = { ok: true; value: number } | { ok: false; revertTo: number }

export function commitHeightFromText(
  raw: string,
  currentHeightCm: number,
  minCm: number = MIN_HEIGHT_CM,
): CommitHeightTextResult {
  const parsed = Number(raw)
  if (!Number.isFinite(parsed)) {
    return { ok: false, revertTo: currentHeightCm }
  }
  return { ok: true, value: clampHeight(parsed, minCm) }
}

export function sliderHeightValue(heightCm: number, sliderMax: number) {
  return Math.min(heightCm, sliderMax)
}

export function heightFromCornerDrag(
  startHeightCm: number,
  startWidthPx: number,
  startHeightPx: number,
  deltaX: number,
  deltaY: number,
) {
  if (startWidthPx <= 0 || startHeightPx <= 0) {
    return clampHeight(startHeightCm)
  }

  const scaleX = 1 + deltaX / startWidthPx
  const scaleY = 1 - deltaY / startHeightPx
  const scale = (scaleX + scaleY) / 2

  return clampHeight(startHeightCm * scale)
}

/** Top-right handle: scale from fixed bottom-left anchor (feet on baseline), grow upward. */
export function heightFromTopRightAnchorDrag(
  startHeightCm: number,
  startDistPx: number,
  currentDistPx: number,
  minCm: number = GRIP_DRAG_MIN_HEIGHT_CM,
) {
  if (startDistPx <= 0 || currentDistPx <= 0) {
    return clampGripDragHeight(startHeightCm, minCm)
  }

  return clampGripDragHeight(startHeightCm * (currentDistPx / startDistPx), minCm)
}
